export default __webpack_public_path__ + "static/media/phsco2.fdc6df3a.png";